export const signIn = () => ({
  type: 'SIGN_IN',
});
export const startTour = () => ({
  type: 'START_TOUR',
});
export const endTour = () => ({
  type: 'END_TOUR',
});
export const enableTimesheetApproval = () => ({
  type: 'ENABLE_TS_APPROVAL',
});
export const disableTimesheetApproval = () => ({
  type: 'DISABLE_TS_APPROVAL',
});
